import React from 'react';
import '@/App.css';
import { AppProvider, useApp } from '@/context/AppContext';
import BottomNav from '@/components/BottomNav';
import HomeScreen from '@/screens/HomeScreen';
import PendingInvoicesScreen from '@/screens/PendingInvoicesScreen';
import UploadInvoiceScreen from '@/screens/UploadInvoiceScreen';
import OCRReviewScreen from '@/screens/OCRReviewScreen';
import UploadSuccessScreen from '@/screens/UploadSuccessScreen';
import UploadStatementScreen from '@/screens/UploadStatementScreen';
import ProductListScreen from '@/screens/ProductListScreen';
import CategoryProductsScreen from '@/screens/CategoryProductsScreen';
import ProductRequestScreen from '@/screens/ProductRequestScreen';
import CheckoutScreen from '@/screens/CheckoutScreen';
import PurchaseSuccessScreen from '@/screens/PurchaseSuccessScreen';
import InvoiceSummaryScreen from '@/screens/InvoiceSummaryScreen';
import ProfileScreen from '@/screens/ProfileScreen';
import { FileText } from 'lucide-react';
import { formatINR } from '@/data/mockData';

const screenMap = {
  HOME: HomeScreen,
  PENDING_INVOICES: PendingInvoicesScreen,
  UPLOAD_INVOICE: UploadInvoiceScreen,
  OCR_REVIEW: OCRReviewScreen,
  UPLOAD_SUCCESS: UploadSuccessScreen,
  UPLOAD_STATEMENT: UploadStatementScreen,
  PRODUCTS: ProductListScreen,
  CATEGORY_PRODUCTS: CategoryProductsScreen,
  PRODUCT_REQUEST: ProductRequestScreen,
  CHECKOUT: CheckoutScreen,
  PURCHASE_SUCCESS: PurchaseSuccessScreen,
  INVOICES: InvoiceSummaryScreen,
  PROFILE: ProfileScreen,
};

function StickyInvoiceCTA() {
  const { navigate, pendingValue } = useApp();
  return (
    <div
      data-testid="sticky-invoice-cta"
      className="bg-[#1E2744] px-4 py-3 flex items-center justify-between flex-shrink-0"
    >
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <FileText size={18} color="white" />
        </div>
        <div>
          <div className="text-white/60 text-[10px] font-bold tracking-widest uppercase">Pending Upload</div>
          <div className="text-white font-bold text-sm">Invoices pending upload</div>
          <div className="text-[#FF7043] text-xs font-semibold">₹{formatINR(pendingValue)} pending</div>
        </div>
      </div>
      <button
        data-testid="sticky-upload-now-btn"
        onClick={() => navigate('PENDING_INVOICES')}
        className="bg-[#FF7043] text-white px-4 py-2.5 rounded-xl font-bold text-xs tracking-wide tap-scale flex-shrink-0"
      >
        UPLOAD NOW
      </button>
    </div>
  );
}

function AppShell() {
  const { currentScreen } = useApp();
  const ScreenComponent = screenMap[currentScreen] || HomeScreen;

  return (
    <div className="app-container">
      <div className="screen-content">
        <ScreenComponent />
      </div>
      {currentScreen === 'HOME' && <StickyInvoiceCTA />}
      <BottomNav />
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <div className="App">
        <AppShell />
      </div>
    </AppProvider>
  );
}

export default App;
